import { render, staticRenderFns } from "./UserFullInformation.vue?vue&type=template&id=c88a3e72&scoped=true"
import script from "./UserFullInformation.vue?vue&type=script&lang=js"
export * from "./UserFullInformation.vue?vue&type=script&lang=js"
import style0 from "./UserFullInformation.vue?vue&type=style&index=0&id=c88a3e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88a3e72",
  null
  
)

export default component.exports